module.exports = __webpack_public_path__ + "img/ico-schedule-chk.c112afce.svg";